module.exports = __webpack_public_path__ + "img/bg-carbon-5.b6fa4e1e.jpg";